export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_75_START_DATE': 'Start Date',
    '_76_TYPE': 'Type',
    '_125_ACTIVE': 'Active',
    '_127_STATUS': 'Status',
    '_713_METRIC': 'Metric',
    '_725_ACTUAL': 'Actual',
    '_763_CLOSE': 'Close',
    '_768___TO_TARGET': '% to Target',
    '_7361_FOCUS': 'Focus',
    '_7332_DISPOSITION': 'Disposition',
    '_7378_COMMITMENT_DETAILS': 'Commitment Details',
    '_7440_CLOSED': 'Closed',
    '_9302_CURRENT_VALUE': 'Current Value',
    '_9473_DAYS_ACTIVE': 'Days Active',
    '_10062_PERCENT_IMPROVEMENT': '% Improvement',
    '_10085_WINNING': 'Winning',
    '_11107_DIRECT_REPORT': 'Direct Report',
    '_11154_IMPROVING': 'Improving',
    '_11155_DECLINING': 'Declining',
    '_11198_VIEW_COMMITMENT': 'View Commitment',
    '_11202_STATE': 'State',
    '_11203_WINS_AT': 'Wins At',
    '_11272_START_VALUE': 'Start Value',
    '_11273_WINNING_THRESHOLD': 'Winning Threshold'
};
